
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $d4fed5120416ae38$exports = {};

$parcel$export($d4fed5120416ae38$exports, "spectrum-IllustratedMessage", function () { return $d4fed5120416ae38$export$e22c6753c239ec31; }, function (v) { return $d4fed5120416ae38$export$e22c6753c239ec31 = v; });
$parcel$export($d4fed5120416ae38$exports, "spectrum-IllustratedMessage--cta", function () { return $d4fed5120416ae38$export$29744d89c9a76d50; }, function (v) { return $d4fed5120416ae38$export$29744d89c9a76d50 = v; });
$parcel$export($d4fed5120416ae38$exports, "spectrum-IllustratedMessage-description", function () { return $d4fed5120416ae38$export$cf9d959111789fe7; }, function (v) { return $d4fed5120416ae38$export$cf9d959111789fe7 = v; });
$parcel$export($d4fed5120416ae38$exports, "spectrum-IllustratedMessage-heading", function () { return $d4fed5120416ae38$export$5df23faa5ed344c4; }, function (v) { return $d4fed5120416ae38$export$5df23faa5ed344c4 = v; });
var $d4fed5120416ae38$export$e22c6753c239ec31;
var $d4fed5120416ae38$export$29744d89c9a76d50;
var $d4fed5120416ae38$export$cf9d959111789fe7;
var $d4fed5120416ae38$export$5df23faa5ed344c4;
$d4fed5120416ae38$export$e22c6753c239ec31 = `TtYriW_spectrum-IllustratedMessage`;
$d4fed5120416ae38$export$29744d89c9a76d50 = `TtYriW_spectrum-IllustratedMessage--cta`;
$d4fed5120416ae38$export$cf9d959111789fe7 = `TtYriW_spectrum-IllustratedMessage-description`;
$d4fed5120416ae38$export$5df23faa5ed344c4 = `TtYriW_spectrum-IllustratedMessage-heading`;


export {$d4fed5120416ae38$exports as default};
//# sourceMappingURL=illustratedmessage_vars_css.mjs.map
